<template>
	<div id="calendar">
		<div style="margin: .3rem 0;padding-left: 1rem;padding-bottom: .8rem;border-bottom: 1px solid #ececec;display: flex;justify-content: space-between;">
			<div>
				<a-select v-model='currentYear' style="width: 6rem" @change="pickYear(currentYear,currentMonth)">
					<a-select-option :value="item" v-for="(item,index) in yearlist" :key='index + "yyysss"'>
						{{item+'年'}}
					</a-select-option>
				</a-select>
				<div class='my_div' @click="pickPre(currentYear,currentMonth)">❮</div>
				<a-select v-model='currentMonth' style="width: 4rem" @change="pickmonth()">
					<a-select-option :value="item" v-for="(item,index) in 12" v-if='item'  :key='index + "yyysslk"'>
						{{item+'月'}}
					</a-select-option>
				</a-select>
				<div class='my_div' @click="pickNext(currentYear,currentMonth)">❯</div>
				<div style="display: inline-block;" :style='{margin:waichu == 1?"0 0.6rem":" 0 1.5rem"}'>
					<img :src="require('@/image/hongkong.png')" alt=""
						style='margin-top: -.2rem;width: 1.6rem;margin-right: .5rem;'>
					<span style="color: #000;font-size: .8rem;">香港假期</span>
					<span style="color: red;font-weight: 700;">
						·
					</span>
				</div>
			</div>
			<div style="display: inline-block;background-color: rgb(246, 246, 246);margin-right: 1rem;
    border-radius: 6px;cursor: pointer;padding: .3rem .6rem;color: #000;font-size: .8rem;" @click="getdateFn()">
				返回今天
			</div>
		</div>
		<!-- 星期 -->
		<ul class="weekdays">
			<li>日</li>
			<li>一</li>
			<li>二</li>
			<li>三</li>
			<li>四</li>
			<li>五</li>
			<li>六</li>
		</ul>
		<ul class="days">
			<li v-for="dayobject in days" :style="{cursor: disabledDate(dayobject.day)?'not-allowed':'pointer',	
			height: lihe||'3.5rem',lineHeight: lihe||'3.5rem'}"
				@click='handfn(dayobject.day)'>
				<!-- <span v-if=""class="other-month">{{ dayobject.day.getDate() }}</span> -->
				<span :class="classfn(dayobject)" :style="stylefn(dayobject)">
					{{ dayobject.day.getDate() }}</span>
				<!-- <div v-if='jiejiari.indexOf(formatDatefn(dayobject.day))>=0' class='dian'>
					·
				</div> -->
				<div v-if='jiejiari.indexOf(formatDatefn(dayobject.day))>=0' style="position: relative;
top: -65%;">
					<img :src="require('@/image/hongkong.png')" alt=""
						style='margin-top: -.2rem;width: 1.6rem;'>
				</div>
			</li>
		</ul>
	</div>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'value',
			event: 'child'
		},
		props: ['stas', 'waichu', 'fdate', 'listdate','asktype','lihe'],
		data() {
			return {
				waichus: 0 || this.waichu, //1 正常 0 今天之后 
				sta: this.stas, //0 单选 //1 多选
				currentDay: 1,
				currentMonth: 1,
				currentYear: 1970,
				currentWeek: 1,
				days: [],
				yearlist: [],
				nowday: '',
				daylist: [],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
					'2022-1-1',
					'2022-2-1',
					'2022-2-2',
					'2022-2-3',
					'2022-4-5',
					'2022-4-15',
					'2022-4-16',
					'2022-4-18',
					'2022-5-2',
					'2022-5-9',
					'2022-6-3',
					'2022-7-1',
					'2022-9-12',
					'2022-10-1',
					'2022-10-4',
					'2022-12-26',
					'2022-12-27'
				],
			}
		},
		created() {
			// this.initData();
		},
		watch: {
			asktype:{
					handler(ev){
						if(ev == 1){
							this.getdateFn()
							this.daylist.length = 0
							this.$emit('child')
						}
					}
				},
			fdate: {
				handler(ev) {
					if (this.fdate) {
						this.nowday = this.fdate
						this.initData(this.formatDate(this.nowday.split('-')[0], this.nowday.split('-')[1], 1));
					}
				}
			},
			listdate: {
				deep: true,
				handler(ev) {
					this.daylist = []
					if (ev.begindates !== '') {
						this.daylist.push(ev.begindates)
						this.initData(this.formatDate(ev.begindates.split('-')[0], ev.begindates.split('-')[1], 1));
					}
					if (ev.enddates !== '') {
						this.daylist.push(ev.enddates)
					}
				}
			}
		},
		mounted() {
			var arr = []
			this.jiejiari.map(ev => {
				arr.push(this.formatDatefn(new Date(ev)))
			})
			this.jiejiari = arr
			var nav = new Date
			for (var i = nav.getFullYear() - 1; i < nav.getFullYear() + 2; i++) {
				this.yearlist.push(i)
			}
			if (!this.fdate) {
				this.$emit('child', this.nowday)
			}
			this.getdateFn()
			this.currentYear = new Date().getFullYear()
		},
		methods: {
			stylefn(dayobject) {
				return {
					color: (dayobject.day.getMonth() + 1 != this.currentMonth) || this.disabledDate(dayobject.day) ?
						'#e1e1e1' : '',
					fontSize: '1rem'
				}
			},
			classfn(dayobject) {
				if (this.sta == 1) {
					//多选
					if (this.daylist.length == 1) {
						return this.daylist.indexOf(this.formatDatefn(dayobject.day)) >= 0 ? 'active' : ''
					}
					if (this.daylist.length == 2) {
						if (this.disabledDate(dayobject.day)) {
							return '';
						}
						let stam = ((new Date(this.daylist[0]) <= new Date(this.formatDatefn(dayobject.day))) &&
							(new Date(this.formatDatefn(dayobject.day)) <= new Date(this.daylist[1]))) ? 'active' : '';
						return stam;
					}
				} else if (this.sta == '0') {
					//选中的颜色 单选
					return (this.nowday == this.formatDatefn(dayobject.day)) ? 'active' : ''
				}
			},
			//今天
			getdateFn() {
				if(!this.disabledDate(new Date())){
					if (this.sta == 1) {
						this.daylist = []
						this.daylist = []
					} else {
						this.nowday = this.formatDatefn(new Date);
					}
					this.handfn(new Date)
				}
				this.initData();
			},
			// <!--v-if="dayobject.day.getFullYear() == new Date().getFullYear() && dayobject.day.getMonth() == new Date().getMonth() && dayobject.day.getDate() == new Date().getDate()"  -->
			formatDatefn(date) {
				// var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? '0' + m : m;
				var d = date.getDate();
				d = d < 10 ? '0' + d : d;
				return y + '-' + m + '-' + d;
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				if (formatDate1 > formatDate2) {
					return true
				} else {
					return false
				}
			},
			handfn(val) {
				let thisday = this.formatDatefn(val)
				//节假日不可以点击
				if (!this.disabledDate(val)) {
					if (this.sta == '1') {
						this.$emit('child',[])
						if (this.daylist.indexOf(thisday) >= 0) {
							this.daylist.splice(this.daylist.indexOf(thisday), 1);
							return
						}
						if (this.daylist.length == 2) {
							this.daylist = []
						}
						if (this.daylist.length == 0) {
							this.daylist.push(thisday)
						} else {
							this.daylist = new Date(thisday) > new Date(this.daylist[0]) ? [this.daylist[0], thisday] : [
								thisday, this.daylist[0]
							]
						}
						
						let num = 0;
						if (this.daylist.length == 2) {
							let _this = this;
							// new Date('2021-06-01').getTime()
							let anum = 0;
							for(let a = new Date(this.daylist[0]).getTime() ;a<=new Date(this.daylist[1]).getTime();a+=24 * 60 * 60 * 1000){
								let tdate = new Date(this.daylist[0])
								tdate.setTime(tdate.getTime()+(24 * 60 * 60 * 1000)*anum);
								let day = tdate.getFullYear()+'-'+(tdate.getMonth()+1) + '-' +tdate.getDate()
								if(!_this.disabledDate(new Date(day))){
									num++
								}
								anum++
							}
						}
						 var day1 = new Date();
						  day1.setTime(day1.getTime()-24*60*60*1000);
						  var s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate();
						  this.$emit('child',this.daylist,num||1)
					} else if (this.sta == '0') {
						//记录点击的日期
						this.nowday = thisday
						//点击是否是当前月
						this.$emit('child', this.nowday)
					}
					if (val.getMonth() + 1 > this.currentMonth) {
						this.pickNext(this.currentYear, this.currentMonth)
					}
					if (val.getMonth() + 1 < this.currentMonth) {
						this.pickPre(this.currentYear, this.currentMonth)
					}
				}
			},
			disabledDate(time) {
				var curDate = new Date();
				var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)
				var str = preDate < new Date(time)
				var strweb = new Date(curDate.getTime() + (24 * 60 * 60 * 1000)*7)< new Date(time)
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(this.formatDatefn(
					time)) >= 0;
				if(this.asktype == 1&&this.stas == 1){
					if(strweb){
						return statenow
					}else{
						return true
					}
				}else if (this.waichus == 1) {
					if (str) {
						return statenow
					} else {
						return true
					}
				} else {
					return statenow
				}
			},
			initData(cur) {
				var leftcount = 0; //存放剩余数量
				var date;
				if (cur) {
					date = new Date(cur);
				} else {
					var now = new Date();
					var d = new Date(this.formatDate(now.getFullYear(), now.getMonth(), 1));
					d.setDate(35);
					date = new Date(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
				}
				this.currentDay = date.getDate();
				this.currentYear = date.getFullYear();
				this.currentMonth = date.getMonth() + 1;

				this.currentWeek = date.getDay(); // 1...6,0
				if (this.currentWeek == 0) {
					this.currentWeek = 7;
				}
				var str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay);
				this.days.length = 0;
				// 今天是周日，放在第一行第7个位置，前面6个
				//初始化本周
				for (var i = this.currentWeek; i > 0; i--) {
					var d = new Date(str);
					d.setDate(d.getDate() - i);
					var dayobject = {}; //用一个对象包装Date对象  以便为以后预定功能添加属性
					dayobject.day = d;
					this.days.push(dayobject); //将日期放入data 中的days数组 供页面渲染使用
				}
				//其他周
				for (var i = 0; i <= 41 - this.currentWeek; i++) {
					var d = new Date(str);
					d.setDate(d.getDate() + i);
					var dayobject = {};
					dayobject.day = d;
					this.days.push(dayobject);
				}
			},
			pickPre(year, month) {
				// setDate(0); 上月最后一天
				// setDate(-1); 上月倒数第二天
				// setDate(dx) 参数dx为 上月最后一天的前后dx天
				var d = new Date(this.formatDate(year, month, 1));
				d.setDate(0);
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
			},
			pickNext(year, month) {
				var d = new Date(this.formatDate(year, month, 1));
				d.setDate(35);
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
			},
			pickYear(year, month) {
				this.initData(this.formatDate(this.currentYear, this.currentMonth, 1))
			},
			pickmonth(year, month) {
				this.initData(this.formatDate(this.currentYear, this.currentMonth, 1))
			},
			// 返回 类似 2016-01-02 格式的字符串
			formatDate(year, month, day) {
				var y = year;
				var m = month;
				if (m < 10) m = "0" + m;
				var d = day;
				if (d < 10) d = "0" + d;
				return y + "-" + m + "-" + d
			},
		}
	}
</script>
<style lang='scss'>
	#calendar {
		.ant-select-selection {
			border: 0 !important;
			outline: none;
		}

		.ant-select-arrow {
			color: #000;
		}
	}
</style>
<style lang='scss' scoped>
	* {
		box-sizing: border-box;
	}

	ul {
		list-style-type: none;
	}

	body {
		font-family: Verdana, sans-serif;
		background: #E8F0F3;
	}

	#calendar {
		/* width: 80%; */
		margin: 0 auto;
		padding: .5rem 0;
		border: 1px solid #ececec;

		/* box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.1), 0 1px 5px 0 rgba(0,0,0,0.12); */
	}

	.month {
		width: 100%;
	}

	.month ul {
		margin: 0;
		padding: 0;
		display: flex;
		justify-content: space-between;
	}

	.year-month {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.year-month:hover {
		background: rgba(150, 2, 12, 0.1);
	}

	.choose-year {
		padding-left: 20px;
		padding-right: 20px;
	}

	.choose-month {
		text-align: center;
		font-size: 12px;
	}

	.arrow {
		padding: 30px;
	}

	.arrow:hover {
		background: rgba(100, 2, 12, 0.1);
	}

	.month ul li {
		color: #000;
		font-size: 12px;
		text-transform: uppercase;
		letter-spacing: 3px;
	}

	.weekdays {
		margin: 0;
		padding: 10px 0;
		color: #666;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}

	.weekdays li {
		display: inline-block;
		width: 13.6%;
		font-size: 1rem;
		text-align: center;
	}

	.days {
		padding: 0;
		background: #FFFFFF;
		margin: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}

	.days li {
		list-style-type: none;
		display: inline-block;
		width: 14.2%;
		text-align: center;
		font-size: 1rem;
		color: #000;
		position: relative;
	}

	.days li .active {
		display: inline-block;
		background: #ff6649;
		border-radius: 4px;
		color: #fff;
	    width: 1.5rem;
	    height: 1.5rem;
		line-height: 1.6rem;
		text-align: center;
	}

	.days li .other-month {
		padding: 5px;
		color: #e1e1e1;
	}

	.days li:hover {
		/* background:  gainsboro; */
	}

	.dian {
		position: absolute;
		color: red;
		left: 1.7rem;
		top: .7rem;
		font-size: 1.3rem;
	}

	.my_div {
		display: inline-block;
		width: 1.5rem;
		/* font-size: 1rem; */
		height: 100%;
		vertical-align: buttom;
		line-height: 1.6rem;
		color: #000;
		/* d4d4d4 */
		text-align: center;
		cursor: pointer;
	}
</style>
